import { store, STATE_LOADING } from "./DataStore";
import { travelData } from "@escapio/portal/state/travelData";
import { data } from "@escapio/shared/state/payload";
import { formatISODate } from "@escapio/shared/l10n/date";

const { hotel } = data;

let tracked = false;
function track(state) {
	if (tracked || state.status === STATE_LOADING) {
		return;
	}

	var params = {
		google_conversion_id: window.google_conversion_id || "",
		google_custom_params: {
			hrental_id: hotel.id,
			hrental_pagetype: "offerdetail",
			...(travelData.hasDates
				? {
						hrental_startdate: formatISODate(travelData.arrival),
						hrental_enddate: formatISODate(travelData.departure),
					}
				: {}),
		},
		google_remarketing_only: true,
	};
	if (state.prices.hasOffers) {
		params["google_custom_params"]["hrental_totalvalue"] = state.prices.offers
			.map(offer => offer.total_rate)
			.sort()[0];
	}

	console.info("Google Remarketing:", params);
	window.google_trackConversion(params);
	tracked = true;
}

window.addEventListener("load", () => {
	if (window.google_trackConversion) {
		track(store.getState());
		store.subscribe(track);
	}
});
